import { render } from "./CreateFeedbackForm.vue?vue&type=template&id=4cc4ea7e"
import script from "./CreateFeedbackForm.vue?vue&type=script&lang=js"
export * from "./CreateFeedbackForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__